import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, CalendarDays, QrCode, User, ScanLine } from "lucide-react";

const items = [
  { to: "/", icon: Home, key: "nav.home", testId: "nav-home" },
  { to: "/events", icon: CalendarDays, key: "nav.events", testId: "nav-events" },
  { to: "/terrain", icon: QrCode, key: "nav.field", testId: "nav-field" },
  { to: "/qr", icon: ScanLine, key: "nav.myQr", testId: "nav-my-qr" },
  { to: "/profile", icon: User, key: "nav.profile", testId: "nav-profile" },
];

export const BottomNav = () => {
  const { t } = useTranslation();
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-card">
      <div className="mx-auto flex max-w-[520px]">
        {items.map(({ to, icon: Icon, key, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex h-16 flex-1 flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${
                isActive ? "text-primary" : "text-muted-foreground"
              }`
            }
          >
            <Icon className="h-5 w-5" />
            {t(key)}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
